<template>
    <div class="main-cn">
        <div class="main-bd mg20 pro-visible">
            <el-row class="searchSection">
                <el-tabs v-if="this.$route.path!='/home/expire-order'" v-model="activeName" @tab-click="handleClick" v-loading="loading">
                    <el-tab-pane label="全部订单" name="all"></el-tab-pane>
                    <el-tab-pane label="协作订单" name="cooperator"></el-tab-pane>
                    <el-tab-pane label="接管订单" name="take_over"></el-tab-pane>
                </el-tabs>
                
                <SearchForm 
                :params="searcherModel" 
                :fields="fields" 
                :cache_field="'search_order_config_' + activeName + '_' + this.$route.path" 
                @search="submitSearch" 
                @reset="resetForm" 
                :key="search_form_key"
                :loading="loading"> 
                </SearchForm>
            </el-row>
            <el-row class="addBtn">
                <el-button type="primary" v-show="Acs('/order/create')" size="small" @click="addOrder()">+ 新增订单
                </el-button>
                <ExportFields 
                    v-if="Acs('/export/order-list')"
                    buttonName="导出订单"
                    url="/api/export/order-list"
                    :params="searcherModel"
                    filename='销售数据表' 
                    title='导出订单数据'
                    :export_field_list="export_field_list"
                    cache_field="export_order_field"
                    :path="this.$route.path"
                    :tab="activeName"
                ></ExportFields>
                
                <TakeOverForm :disabled="multipleSelection.length == 0" v-if="this.$route.path == '/order/my-order' && activeName!='take_over' && Acs('/user-orders/take-over')" buttonName="接管订单" :order_ids='order_ids' @change='updateTakeOver' :key="take_over_key"></TakeOverForm>
                
            </el-row>
            <div v-if="activeName=='all'">
                当前页业绩总金额:<span style="color: red;">{{orderSensitiveMasked ? '******' : _.round(total_performance_account, 2)}}</span>
                当前页续费总金额:<span style="color: red;">{{orderSensitiveMasked ? '******' : _.round(total_renew_account, 2)}}</span>
                当前页回款总金额:<span style="color: red;">{{orderSensitiveMasked ? '******' : _.round(total_repay_account, 2)}}</span>
            </div>
            <el-table :data="list" style="width: 100%" v-loading="loading"
                      class="scrollbar tabTopBorder order-tab-list" @sort-change="submitSearch(null, $event)" v-watermask @selection-change="handleSelectionChange">
                <el-table-column type="selection" prop="checkbox" width="55"></el-table-column>
                <el-table-column label="订单ID">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleView(scope.row)">
                            {{ scope.row.id }}
                        </el-button>
                        <br>
                        <span style="color: #F56C6C" v-if="scope.row.user.length > 1 && scope.row.products.length > 0"><OrderCor :user_list="scope.row.user" :product_list="scope.row.products"></OrderCor></span>
                    </template>
                </el-table-column>
                <el-table-column label="客户名称">
                    <template slot-scope="scope">
                        <div v-for="user in scope.row.user" :key="user.id">
                            <el-tooltip placement="bottom-start" v-if="!loading && user.is_cooperator == 0">
                                <div slot="content">
                                    <span>绑定业务员</span><span class="user-tooltip">绑定时间</span><br/><br/>
                                    <span>{{scope.row.customers && scope.row.customers.user_name ? scope.row.customers.user_name : '无'}}</span>
                                    <span class="user-tooltip">{{scope.row.customers ? scope.row.customers.bind_at : ''}}</span>
                                </div>
                                <div>
                                    <a v-if="Acs('/customers/view')" style="color: #1890ff" @click="toCustomer(scope.row)">{{scope.row.customer_name}}</a>
                                    <a style="color: #1890ff" v-else>{{scope.row.customer_name}}</a>
                                </div>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="客户ID">
                    <template slot-scope="scope">
                      <a v-if="Acs('/customers/view')" style="color: #1890ff" @click="toCustomer(scope.row)">{{scope.row.customer_id}}</a>
                        <br>
                        <span style="color: #F56C6C" v-if="scope.row.user.length > 1 && scope.row.products.length > 0"><OrderCor :user_list="scope.row.user" :product_list="scope.row.products"></OrderCor></span>
                    </template>
                </el-table-column>
                <el-table-column prop="level_name" label="成交产品" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.products.length == 1">
                            <span v-if="scope.row.products[0].is_new == 0">
                                <el-button size="mini" type="primary" v-if="scope.row.products[0].is_active > 0">
                                    {{ scope.row.products[0].product_name }}
                                </el-button>
                                <el-button size="mini" type="info" v-else>{{ scope.row.products[0].product_name }}
                                </el-button>
                            </span>
                        </div>
                        <div v-else-if="scope.row.products.length > 1">
                            <el-tooltip class="item" effect="dark" placement="bottom">
                                <div slot="content" v-for="value in scope.row.products" :key="value.id" v-show="value.is_new == 0">
                                    <el-button size="mini" type="primary" v-if="value.is_active > 0">{{ value.product_name
                                        }}
                                    </el-button>
                                    <el-button size="mini" type="info" v-else>
                                        {{ value.product_name }}
                                    </el-button>
                                </div>
                                <span v-if="scope.row.products[0].is_new == 0">
                                    <el-button size="mini" type="primary" v-if="scope.row.products[0].is_active > 0">
                                        {{ scope.row.products[0].product_name }}
                                    </el-button>
                                    <el-button size="mini" type="info" v-else>
                                        {{ scope.row.products[0].product_name }}
                                    </el-button>
                                </span>
                                <span v-else>
                                    <el-button size="mini" type="primary" v-if="scope.row.products[1].is_active > 0">
                                        {{ scope.row.products[1].product_name }}
                                    </el-button>
                                    <el-button size="mini" type="info" v-else>
                                        {{ scope.row.products[1].product_name }}
                                    </el-button>
                                </span>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="订单负责人">
                    <template slot-scope="scope">
                        <div v-for="(user, index) in scope.row.user" :key="user.id">
                            <el-tooltip placement="bottom-start" v-if="!loading && user.is_cooperator == 0" :key="index">
                                <div slot="content">
                                    <span>接管人：{{user.take_over_name}}</span>
                                </div>
                                <div>
                                    {{user.user_name}}
                                </div>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="审核状态" prop="status_memo"  width="140">
                    <template slot-scope="scope">
                        <span v-if="searcherModel.close">
                            <span style="color: #67C23A" v-if="scope.row.close_audit==1 ">审核通过</span>
                            <el-tooltip v-else effect="dark" placement="right-start">
                                <!-- <span slot="content">待【{{scope.row.close_auditor}}】审核</span> -->
                                <span style="color: #E6A23C">待审核</span>
                            </el-tooltip>
                        </span>
                        <span v-else>
                            <el-tooltip v-if="scope.row.finance_audit==1 && scope.row.contract_audit == 1 "
                                        effect="dark"
                                        placement="right-start">
                            <span slot="content"><span v-html="showContent(scope.row)"></span></span>
                            <span style="color: #67C23A">审核通过</span>
                            </el-tooltip>
                            <el-tooltip v-else-if="scope.row.finance_audit==0 && scope.row.contract_audit ==0 "
                                        effect="dark" :content="showContent(scope.row)" placement="right-start">
                                <span slot="content"><span v-html="showContent(scope.row)"></span></span>
                                <span style="color: #F56C6C">不通过</span>
                            </el-tooltip>
                            <span v-else effect="dark" placement="right-start">
                                <span slot="content"><span v-html="showContent(scope.row)"></span></span>
                            </span>
                        </span>

                    </template>
                </el-table-column>
                <el-table-column prop="type_memo" label="订单类型"></el-table-column>
                <el-table-column prop="sign_mode_str" label="签单模式"></el-table-column>
                <el-table-column prop="source_str" label="成交来源"></el-table-column>
                <el-table-column prop="contracts" label="传附时间">
                    <template slot-scope="scope">
                        <span v-if="scope.row.contracts.length">
                            {{scope.row.contracts[0].created_at}}
                        </span>
                        <span v-else>
                            未上传合同附件
                        </span>
                    </template>
                </el-table-column>
                <el-table-column width="100px" sortable="created_at" prop="created_at"  label="录单时间">
                    <template slot-scope="scope">
                        <span v-if="scope.row.created_at">
                            {{scope.row.created_at}}
                        </span>
                        <span v-else>
                            0
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="pay_time" width="100px" sortable="pay_time" label="回款时间">
                    <template slot-scope="scope">
                          <span v-if="scope.row.actual_at">
                            <el-button type="text" @click="showPlayPayDialog(scope.row)" :loading="pay_loading"> {{scope.row.actual_at}}</el-button>
                        </span>
                        <span v-else>
                             无回款记录
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="合同有效期" width="185px" align="center" sortable="contract_time" prop="contract_time">
                    <template slot-scope="scope">
                        <span width="400px" v-if="scope.row.financeCount">
                            <el-tooltip  class="item" effect="dark" placement="bottom">
                                <div slot="content"   class="line-gap">{{scope.row.financeCount.contract_start_time}}~{{scope.row.financeCount.contract_end_time}}
                                </div>
                                <el-tag width="400px">{{scope.row.financeCount.contract_start_time}}-{{scope.row.financeCount.contract_end_time}}</el-tag>
                            </el-tooltip>
                        </span>
                        <span v-else>
                            无
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="total_amount" label="合同">
                    <template slot-scope="scope">
                        <span v-if="scope.row.financeCount">
                            {{scope.row.financeCount['total_amount']}}
                        </span>
                        <span v-else>
                            0
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="total_renew_amount" label="续费"></el-table-column>
                <el-table-column prop="total_pfm_amount" label="新增"></el-table-column>
                <el-table-column label="回款" style="z-index:222; background: #fff">
                    <template slot-scope="scope">
                        <div v-if="scope.row.order_sensitive_masked">******</div>
                        <div v-else-if="scope.row.financeCount && scope.row.payLog">{{
                            _.reduce(scope.row.payLog, (memo, item) => {
                            return memo + (Number(item.actual_amount) || 0)
                            }, 0)
                            }}
                        </div>
                        <div v-else>0</div>
                    </template>
                </el-table-column>
                <el-table-column prop="total_finish_amount" label="续费完成额"></el-table-column>
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button @click="handleView(scope.row)" type="text" size="small">查看</el-button>
                        <el-button @click="handleCloseOrder(scope.row)" v-if="((Acs('/order/trial-order-close') && scope.row.type == 1) || (Acs('/order/close') && scope.row.type != 1)) && (scope.row.close_audit != 1)" type="text"
                                   size="small">关闭
                        </el-button>
                        <el-button v-if="scope.row.type != 1 && scope.row.business_audit == 1 && scope.row.close_audit == 0"
                                   @click="renew(scope.row)" type="text" size="small">续约
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--回款计划展示-->
            <el-dialog title="回款信息" width="75%" :visible.sync="showDialogPay">
                <plan-pay :order="plan_pay_order" :hidden-action="true"></plan-pay>
                <div slot="footer" style="text-align: center;">
                    <el-button type="primary" @click="showDialogPay=false">关闭</el-button>
                </div>
            </el-dialog>
            <!--关闭订单弹窗-->
            <el-dialog title="关闭订单" :visible="dialogCloseOrder" :before-close="close">
                <close-form :order="closeOrder" @closeDialog="closeDialog"></close-form>
            </el-dialog>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage"></pagination>
            </el-row>
        </div>
        
    </div>
</template>
<style>
    .pro-visible .el-tag {
        max-width: 200px;
    }
    .scrollbar .el-table__body-wrapper::-webkit-scrollbar {
        width: 1px; /*一定要给高度，不然下面的样式无效，很蛋疼*/
    }

    .scrollbar .el-table__body-wrapper::-webkit-scrollbar-thumb {
        background: #99a9bf;
        border-radius: 5px;
    }
    .user-tooltip{
        margin-left: 60px;
    }
</style>
<script>
    import Pagination from "~/widgets/Pagination.vue";
    import OrderService from "~/services/order";
    import Config from "~/config/params";
    import PlanPay from "~/views/order/partial/order_plan_pay.vue";
    import CloseForm from "~/views/order/closeForm.vue";
    import OrderCor from "~/widgets/OrderCor.vue";
    import ExportFields from "~/widgets/ExportFields.vue";
    import SearchForm from "~/widgets/SearchForm.vue";
    import TakeOverForm from "~/views/order/dialog/takeOverForm.vue";
    export default {
        components: {
            Pagination,
            Config,
            PlanPay,
            CloseForm,
            OrderCor,
            ExportFields,
            SearchForm,
            TakeOverForm
        },
        data() {
            return {
                ExportDialogVisible: false,
                showDialogPay: false,
                plan_pay_order: false,
                leftIsShow: true,
                rightIsShow: false,
                dialogCloseOrder: false,
                performance_amount: 0,
                total_performance_account: 0,
                total_repay_account: 0,
                total_renew_account: 0,
                orderSensitiveMasked: false,
                order_type: [],
                export_field_list: [],
                maturity: {},
                searcherModel: {},
                list: [],
                loading: true,
                // 分页信息
                linkPage: null,
                closeOrder: {},
                exportLoading: false,
                exportParams:{},

                showTooltip: false, //订单负责人悬浮窗
                
                fields: [],
                search_form_key: 0,
                multipleSelection: [],
                order_ids: [],
                activeName: 'all',
                take_over_key: 0,
                pay_loading: false,
            };
        },
        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function (to, from, next) {
            this.searcherModel['page'] = to.query["page"];
            this.searcherModel['perPage'] = to.query["perPage"];
            this.submitSearch();
        },
        /**
         * 监听组件切换变化
         */
        watch: {
            $route(to, from) {
                this.activeName = 'all';
                this.resetForm();
            },
            list() {
                this.orderSensitiveMasked = this.list.some(item => item.order_sensitive_masked);
                if (this.orderSensitiveMasked) {
                    this.total_performance_account = 0;
                    this.total_repay_account = 0;
                    this.total_renew_account = 0;
                    return;
                }
                if (this.list && this.list.length > 0) {
                    this.list.forEach(customer => {
                        customer.performance_total_amount = _.reduce(customer.user, (memo, item) => {
                            return memo + (parseFloat(item.pfm_amount) || 0)
                        }, 0);
                        customer.already_pay = _.reduce(customer.plan_pay, (memo, item) => {
                            return memo + parseFloat(item.actual_amount)
                        }, 0);
                    });
                    this.total_performance_account = _.reduce(this.list, (memo, item) => {
                        return memo + (parseFloat(item.performance_total_amount) || 0)
                    }, 0);
                    this.total_repay_account = _.reduce(this.list, (memo, item) => {
                        let sum_pay = item.financeCount && item.payLog && item.payLog.length > 0 ? _.sumBy(item.payLog, log => parseFloat(log.actual_amount)) : 0;
                        return memo + sum_pay;
                    }, 0);
                    this.total_renew_account = _.reduce(this.list, (memo, item) => {
                        if (item.financeCount && item.financeCount.renew_amount) {
                            return memo + (parseFloat(item.financeCount.renew_amount) || 0)
                        }
                        return memo;
                    }, 0);
                } else {
                    this.total_performance_account = 0;
                    this.total_repay_account = 0;
                    this.total_renew_account = 0;
                }
            }
        },
        created: function () {
            OrderService.getOrderExportFields().forEach(item => {
                if(this.Acs('/export/order-list-' + item.field)){
                    this.export_field_list.push(item);
                }
            });
            this.resetForm();
        },

        methods: {
            showContent(row) {
                return OrderService.showCheckInfo(row);
            },

            showPlayPayDialog(row) {
                this.pay_loading = true;
                OrderService.getDetail(row.id).then(res => {
                    if(res && res.code == 0){
                        this.plan_pay_order = res.data;
                        this.showDialogPay = true;
                    }
                    this.pay_loading = false;
                }).catch(err => {
                  this.pay_loading = false;
                  console.error(err);
                });
            },

            showPlayPay(row) {
                if (!row.financeCount) return false;
                if (row.payLog.length === 0) return false;
                let plan_pay = row.payLog.filter(item => {
                    return item.actual_at;
                });
                if (plan_pay.length === 0) return false;
                return plan_pay;
            },

            //关闭dialog弹窗
            close() {
                this.dialogCloseOrder = false;
            },

            //关闭dialog订单
            handleCloseOrder(row) {
                this.closeOrder = Object.assign({}, row);
                this.close_reason = '';
                this.dialogCloseOrder = true;
            },

            //全部订单列表
            orderList(params = {}) {
                OrderService.list(params).then(res => {
                    this.loading = false;
                    this.list = res.data;
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                }).catch(err => {
                  this.loading = false;
                  console.error(err);
                });
            },

            //我的订单列表
            myOrderList(params = {}) {
                OrderService.myList(params).then(res => {
                    this.loading = false;
                    this.list = res.data;
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                }).catch(err => {
                  this.loading = false;
                  console.error(err);
                });
            },
            
            initListData(params = {}) {
                // loading 动画
                this.loading = true;
                if (this.$router.currentRoute.path == '/order/my-order') {
                    this.myOrderList(params);
                } else if (this.$router.currentRoute.path == '/order/index') {
                    this.orderList(params);
                }else if(this.$route.path=='/home/expire-order'){
                    this.searcherModel.type = 4;
                    params.tab = 'expireOrder';
                    this.myOrderList(params);
                }
            },

            // 筛选查询
            submitSearch(params = null, column = null) {
                // console.log('submitSearch: ', params, this.searcherModel);
                this.list = [];
                // loading 动画
                this.loading = true;
                if(column && (column.prop !=null || column.order !=null)){
                    this.searcherModel.sort_name =column.prop;
                    this.searcherModel.sort_by = column.order;
                }
                if(params){
                    this.searcherModel = params;
                }
                params = _.clone(this.searcherModel);
                _.each(params, (val, key) => {
                    // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                    if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                        delete params[key];
                    }
                })
                
                this.initListData(params);
            },

            resetFields() {
                this.searcherModel = {
                    id: '',
                    tab: this.activeName,
                    type: 4,
                    repay_type: '',
                    customer_name: '',
                    contract_number: '',
                    salesman: '',
                    product_id: '',
                    close_audit: '',
                    is_close: 0,
                    close_type: '',
                    finance_audit: '',
                    business_audit: '',
                    contract_audit: '',
                    contract_start_time: [],
                    contract_end_time: [],
                    send_time: [],
                    created_time: [],
                    plan_time: [],
                    pay_time: [],
                    upload_file_time: [],
                    province_id: 0,
                    city_id: 0,
                    district_id: 0,
                    sort_by:'',
                    sort_name:'',
                    branch_id: '',
                    source: '',
                    stage: '',
                    cooperate_status: '',
                    total_amount_type: '',
                    path: this.$route.path,
                    sign_mode: '',
                    revise_audit_time: [], // 添加修订审核时间
                    close_audit_time: [], // 添加关闭审核时间
                };
                // console.log('初始化筛选：', this.searcherModel);
            },
            
            // 重置筛选表单
            resetForm() {
                this.resetFields();
                if(this.$route.query['active']){
                    this.activeName = this.searcherModel.tab = this.$route.query['active'];
                }
                this.order_type = [];
                this.searcherModel.type = Config.TYPE_FORMAL_AND_RENEW;
                this.fields = OrderService.getFields(this.searcherModel);
                this.search_form_key ++;
                this.submitSearch();
                // console.log('重置条件：', this.fields)
            },

            handleView(order) {
                let params = {id: order.id};
                let routeData = this.$router.resolve({
                    path: "/order/view",
                    query: params,
                });
                window.open(routeData.href, '_blank');
            },

            addOrder() {
                this.$router.push({
                    path: "/order/create",
                    query: {
                        referer: this.$route.path
                    }
                });
            },

            toCustomer(row) {
                let path = "/customers/view?id=" + row.customer_id;
                let to = this.$router.resolve({
                    path: path
                });
                window.open(to.href, '_blank');
            },
            
            renew(obj) {
                let path = "/order/renew?id=" + obj.id;
                this.$router.push({
                    path: path,
                    query: {
                        referer: this.$route.path
                    }
                });
            },

            closeDialog(submit) {
                this.dialogCloseOrder = false;
            },

            handleClick(tab, event) {
                this.searcherModel.tab = tab;
                this.resetForm();
            },

            handleSelectionChange(val) {
                this.multipleSelection = val.filter(item => !item.confirm_at);
                this.order_ids = this.multipleSelection.map(item => item.id);
                this.take_over_key ++;
                // console.log('handleSelectionChange: ', this.multipleSelection);
            },

            updateTakeOver(){
                this.submitSearch();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/order/list.vue